skrilla.controller('permissionsCtrl', function ($scope, searchService, queryService, countryService) {

    countryService.getQueryableCountries().then(function(countries){$scope.countries = countries;});
    $scope.permissionCodes = [
        "deposit_AUD",
          "withdraw_AUD",
          "submitFreeRoster",
          "submitPaidRoster",
          "deposit",
          "withdraw",
          "submitBet",
          "submitLiveBet",
          "viewLiveMarkets",
          "claimPromotionCode",
          "claimReferralCode",
          "viewContest"
    ];
    $scope.locationTypes = [
      "PHYSICAL",
      "RESIDENTIAL",
      "PHYSICAL_ANONYMOUS",
    ]

  $scope.reset = function () {
    $scope.query = {
            countryISOCode: null,
            permission: null,
            locationType: null
        };
    };
    $scope.reset();


    $scope.search = function() {
        return searchService.get("permissions" + queryService.getQueryString($scope.query)).then(function (response) {
            $scope.permissions = response.data;
        });
    }
  $scope.clearCache = function() {
    return searchService.deleteRequest("permissions/cache").then(function (response) {
    });
  }

  $scope.search();
});

